/**
 * Configuração do formulário de Motoristas
 */

// Função auxiliar para validar CPF
const validarCPF = (cpf) => {
  if (!cpf) return false;
  const cleaned = cpf.replace(/\D/g, '');

  if (cleaned.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cleaned)) return false;

  let soma = 0;
  let resto;

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cleaned.substring(i - 1, i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cleaned.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cleaned.substring(i - 1, i)) * (12 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cleaned.substring(10, 11))) return false;

  return true;
};

// Estrutura dos campos do formulário
export const formStructure = [
  // Linha 1: Nome
  [
    {
      name: 'Nome',
      label: 'Nome Completo',
      type: 'text',
      component: 'FormField',
      placeholder: 'Digite o nome completo do motorista',
      colProps: { md: 12 },
      maxLength: 100,
      validation: {
        required: 'Nome é obrigatório',
      },
    },
  ],
  // Linha 2: CPF e Código de Integração
  [
    {
      name: 'Cpf',
      label: 'CPF',
      component: 'MaskedInput',
      type: 'text',
      placeholder: 'Digite o CPF',
      colProps: { md: 6 },
      mask: [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/],
      guide: false,
      validation: {
        required: 'CPF é obrigatório',
      },
    },
    {
      name: 'CodigoIntegracao',
      label: 'Código de Integração',
      type: 'text',
      component: 'FormField',
      placeholder: 'Digite o código de integração (opcional)',
      colProps: { md: 6 },
      maxLength: 50,
    },
  ],
  // Linha 3: Tipo e Status
  [
    {
      name: 'Tipo',
      label: 'Tipo de Motorista',
      component: 'SearchSelect',
      placeholder: 'Selecione o tipo',
      minSearchLength: 0,
      colProps: {
        md: 4
      },
      options: [
        { value: 'Terceiro', label: 'Terceiro' },
        { value: 'Próprio', label: 'Próprio' },
      ],
    },
    {
      name: 'Ativo',
      label: 'Ativo',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 6 },
    },
  ],
];

// Seções do formulário
export const formSections = (initialValues) => [
  {
    title: 'Dados do Motorista',
    rows: [0, 1, 2], // Linhas 1-3
  },
];

// Validação do formulário
export const validateForm = (values) => {
  const errors = {};

  // Nome obrigatório
  if (!values.Nome || values.Nome.trim() === '') {
    errors.Nome = 'Nome é obrigatório';
  } else if (values.Nome.trim().length < 3) {
    errors.Nome = 'Nome deve ter no mínimo 3 caracteres';
  } else if (values.Nome.trim().length > 100) {
    errors.Nome = 'Nome deve ter no máximo 100 caracteres';
  }

  // CPF obrigatório e válido
  if (!values.Cpf || values.Cpf.trim() === '') {
    errors.Cpf = 'CPF é obrigatório';
  } else if (!validarCPF(values.Cpf)) {
    errors.Cpf = 'CPF inválido';
  }

  // Código de Integração (opcional, mas com limite)
  if (values.CodigoIntegracao && values.CodigoIntegracao.length > 50) {
    errors.CodigoIntegracao = 'Código de integração deve ter no máximo 50 caracteres';
  }

  // Tipo obrigatório
  if (!values.Tipo || values.Tipo === '') {
    errors.Tipo = 'Tipo de motorista é obrigatório';
  } else if (values.Tipo !== 'Terceiro' && values.Tipo !== 'Próprio') {
    errors.Tipo = 'Tipo deve ser "Terceiro" ou "Próprio"';
  }

  return errors;
};

// Valores iniciais
export const initialValues = {
  Nome: '',
  Cpf: '',
  CodigoIntegracao: '',
  Tipo: 'Terceiro',
  Ativo: true,
};
